export enum EPlatform {
  iOS = 'ios',
  Android = 'android',
}
